/* eslint-disable */
import { zxy as CaCheStore } from './http-cache-store';
import axios from 'axios';

/* request pool */
const pending = [];
function NewHttp(cacheConfig = {}) {
    const { isExpired } = cacheConfig;

    this.http = axios; // 保留原始axios
    this.isOpen = cacheConfig.isCache; // 一级开关
    this.cacheConfig = cacheConfig; // 缓存配置
    this.baseCacheConfig = cacheConfig; // base缓存配置
    this.zxyCacheStorage = { // 存储桶
        zxyStore: new CaCheStore({ storage: 'zxyStore', exp: isExpired }),
        localStorage: new CaCheStore({ storage: 'localStorage', exp: isExpired }),
        sessionStorage: new CaCheStore({ storage: 'sessionStorage', exp: isExpired }),
    };
}

NewHttp.prototype = {
    setCurrentKey(key) {
        let currentKey;

        if (window.app && window.app.global && window.app.global.organization && window.app.global.organization.id) {
            currentKey = `${window.app.global.organization.id}_${key}`;
        } else if (localStorage.getItem('user') && JSON.parse(localStorage.getItem('user') || '{}').id) {
            currentKey = `${JSON.parse(localStorage.getItem('user') || '{}').id}_${key}`;
        } else {
            currentKey = key;
        }

        return currentKey;
    },

    wrapRequest(opts = {}) {
        this.cacheConfig = { ...this.baseCacheConfig, ...opts };

        if (this.isOpen && this.cacheConfig.isCache) { // 一级开关 组合 二级开关
            let cacheKey = this.cacheKey(this.cacheConfig);
            cacheKey = this.setCurrentKey(cacheKey);

            /* get cache */
            const cacheData = this.zxyCacheStorage[this.cacheConfig.isStorage].get(cacheKey);
            // cacheData && console.log('取', cacheKey);
            cacheData && console.log('%c from memory cache:', 'font-size:15px;color:red;', cacheData);
            /* return cache */
            if (cacheData) return Promise.resolve(cacheData);
        }

        return this.http.request(opts);
    },

    httpRequest() {
        const { isCache } = this.cacheConfig;

        if (this.isOpen && isCache) {
            ['get', 'delete', 'head', 'jsonp'].forEach((method) => {
                /* rewrite http */
                this.http[method] = (url, config) => {
                    return this.wrapRequest({ url, ...config, method });
                };
            });
        }
    },

    axiosInterceptor() {
        const removePending = (cfg) => {
            for (const p in pending) {
               let cacheKey = this.cacheKey(cfg);

                if (pending[p].key === this.setCurrentKey(cacheKey)) {
                    pending[p].fn && pending[p].fn();
                    pending.splice(p, 1);
                }
            }
        };

        /* request interceptors */
        this.http.interceptors.request.use((cfg) => {
            /* default cacheConfig */
            let { isCache, isStorage, isExpired } = this.cacheConfig;

            if (this.isOpen && isCache) {
                removePending(cfg);

                /* add cancelToken */
                cfg.cancelToken = new this.http.CancelToken((c) => {
                    let cacheKey = this.cacheKey(cfg);

                    cacheKey = this.setCurrentKey(cacheKey);
                    pending.push({ key: cacheKey, fn: c });
                });

                if (cfg.data) {
                    /* single interface cfg */
                    isStorage = cfg.data.isStorage || isStorage;
                    isExpired = cfg.data.isExpired || isExpired;
                    isCache = cfg.data.isCache || isCache;

                    delete cfg.data.isStorage;
                    delete cfg.data.isExpired;
                    delete cfg.data.isCache;
                }
            }

            return cfg;
        });

        /* response interceptors */
        this.http.interceptors.response.use((res) => {
            const { isCache, isStorage, isExpired } = this.cacheConfig;

            if (this.isOpen && isCache) {
                removePending(res.config);

                let storage = this.zxyCacheStorage[isStorage];
                let cacheKey = this.cacheKey(this.cacheConfig);

                cacheKey = this.setCurrentKey(cacheKey);
                // console.log('存', res.config, cacheKey)
                storage.deleteAllExpires();

                if (!storage.get(cacheKey)) {
                    storage.set(cacheKey, res, { exp: isExpired });
                }
            }

            return res;
        }, (err) => {
            return Promise.reject(err);
        });
    },

    cacheKey(opts = {}) {
        var url = opts.url.split('?')[0], str;
        var type = (opts.type || opts.method).toUpperCase();
        var data = opts.data || opts.params && JSON.stringify(opts.params);
        
        url = url.indexOf('/') !== 0 ? `/${url}` : url;
        str = type + url;
        
        if (data) {
          str += data;
        } else {
          str = type + opts.url;
        }

        return str;
    }

};

const HttpCacheMiddleware = function (cfg = {}) {
    const cacheConfig = {
        isCache: false,
        isStorage: 'zxyStore',
        isExpired: 10,
        ...cfg
    };

    const httpX = new NewHttp(cacheConfig);

    httpX.axiosInterceptor();
    httpX.httpRequest();
    window.zxyVueCacheStorage = httpX.zxyCacheStorage;
};

export { HttpCacheMiddleware };
